// register(email, password, firstName, lastName).done(function (html) {
  
//   // logic for registration errors
//   if (html.indexOf('email is invalid') !== -1) {
     
//   } else if (html.indexOf('email cannot be blank') !== -1) { 
    
//   } else if (html.indexOf('password cannot be blank.') !== -1) {
      
//   }

// });

function login(email, password) {  
  var data = {
    'customer[email]': email,
    'customer[password]': password,
    form_type: 'customer_login',
    utf8: '✓'
  };

  var promise = $.ajax({
    url: '/account/login',
    method: 'post',
    data: data,
    dataType: 'html',
    async: true
  });

  return promise;
}

function register(email, password, firstName, lastName) {  
  var data = {
    'customer[email]': email,
    'customer[password]': password,
    'customer[first_name]': firstName,
    // 'customer[last_name]': lastName,
    form_type: 'create_customer',
    utf8: '✓'
  };

  var promise = $.ajax({
    url: '/account',
    method: 'post',
    data: data,
    dataType: 'html',
    async: true
  });

  return promise;
}

function getCheckoutUrl() {  
  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
  return getParameterByName('checkout_url');
}